import * as React from 'react';
import * as classNames from 'classnames';
import {Checkbox} from '../checkbox/checkbox';

import {
    consent  as cssConsent,
    checkbox as cssCheckbox,
} from '../terms-consent/terms-consent.module.sass';

export const MarketingConsent: React.SFC<React.InputHTMLAttributes<HTMLInputElement>> = (
    {className, ...props}
) => (
    <div className={classNames(cssConsent, className)}>
        <Checkbox className={cssCheckbox} {...props} />
        <div>I want to get your awesome emails</div>
    </div>
);
